const GENDERS=['male','female','non-binary'];export default GENDERS;